import { Directive, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { CanComponentDeactivate } from './guards/pending-changes-guard.guard';

@Directive()
export abstract class BaseFormComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  forms: FormGroup[] = []; // ✅ بدل form واحد بقى عندنا array
  isSubmitDisabled = false;

  ngOnInit(): void {
    // window.addEventListener('beforeunload', this.beforeUnloadHandler);
  }

  ngOnDestroy(): void {
    // window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  private beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    if (this.hasDirtyForms() && !this.isSubmitDisabled) {
      event.preventDefault();
      event.returnValue = '';
    }
  };

  private hasDirtyForms(): boolean {
    return !!(this.forms.some(form => form?.dirty) || this.hasChanged?.());
  }
  hasChanged?(): boolean;

  async canDeactivate(): Promise<boolean> {
    if (this.isSubmitDisabled || !this.hasDirtyForms()) {
      return true;
    }

    const result = await Swal.fire({
      title: 'لديك تعديلات غير محفوظة',
      text: 'ماذا تريد أن تفعل قبل الخروج؟',
      icon: 'warning',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: '💾 حفظ',
      denyButtonText: '🗑️ تجاهل',
      cancelButtonText: '❌ إلغاء'
    });

    if (result.isConfirmed) {
      await this.save();
      return true;
    } else if (result.isDenied) {
      return true;
    } else {
      return false;
    }
  }

  abstract save(): Promise<void>;
}
